import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex operator-application-dialog" }
const _hoisted_2 = {
  key: 1,
  class: "text-center w-100",
  style: {"padding-top":"3em"}
}

import {ref, computed, inject, onMounted, provide} from 'vue';
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ForwardToOperatorEventInterface
    from "~/operatorApplication/vue/dialogs/dialog/topmenu/ForwardToOperatorEventInterface";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OperatorApplicationCobrowse
    from "~/operatorApplication/vue/dialogs/dialog/cobrowse/OperatorApplicationCobrowse.vue";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {SHORTCUT_TOGGLE_COBROWSE} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import DialogSideMenu
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/DialogSideMenu.vue";
import OperatorApplicationExportPayloadDialogInterface
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationExportDialogInterface";
import {isInSelectedSectionInjectionKey} from "~/operatorApplication/vue/layout/OperatorApplicationSectionInjection";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import useActivated from "~/ts/vuePlugins/useActivated";
import toggleClientMute from "~/operatorApplication/ts/service/buddyList/toggleClientMute";
import {SHOW_MESSAGE_STATUS_INJECTION_KEY} from "~/core-ui/vue/chat/CoreUiChatHistoryExposeInterface";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";
import DialogChatArea
    from "~/operatorApplication/vue/dialogs/dialog/DialogChatArea.vue";
import {
    DialogChatAreaExposeInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";



const __default__ = {
    name: "OperatorApplicationDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    username: {},
    buddyList: {}
  },
  setup(__props: any) {

let props = __props;

let showMessageSearch = ref(false);
let chatArea = ref<DialogChatAreaExposeInterface>();

let isInSelectedSection = inject(isInSelectedSectionInjectionKey);

let forceShowSideMenu = ref(false);

let isActivated = useActivated();
onMounted(() => {
    addDisposableEvent(OperatorApplicationEventManager.addEventListener(
        SHORTCUT_TOGGLE_COBROWSE,
        () => {
            if (isInSelectedSection.value && isActivated.value) {
                toggleCobrowse();
            }
        }
    ));
});

let cobrowse = computed({
    get: () => {
        return (
            ClientUserdataStore.isCobrowseEnabled(props.username)
            &&
            OperatorAccountStore.data.value.accessRights.canCobrowse
        );
    },
    set: (value: boolean) => {
        ClientUserdataStore.SET_COBROWSE_ENABLED({username: props.username, value});
    }
});


let userdata = computed(() => {
    return ClientUserdataStore.getByUsername(props.username);
});

let site = computed(() => {
    return userdata.value ? OperatorAccountStore.sitesDictionary.value[userdata.value.siteId] : null;
});


async function onForward(payload: ForwardToOperatorEventInterface) {
    let p: OperatorApplicationApi.OperatorForwardClientOpenApiModel = {
        username: props.username,
        operatorLogin: payload.operatorLogin ? payload.operatorLogin : undefined,
        groupId: payload.groupId ? payload.groupId : undefined
    };
    (await (new OperatorApiRequest({
        url: "/message/forwardClient",
        p,
        silent: true
    })).send()).showMessageOnError();
}

async function onExportDialog(payload: OperatorApplicationExportPayloadDialogInterface) {
    let p: OperatorApplicationApi.OperatorExportClientToEmailOpenApiModel = {
        username: props.username,
        email: payload.email,
        messageIds: chatArea.value.getSelectedMessages().map(message => message.id),
        forClient: payload.forClient
    };
    (new OperatorApiRequest({
        url: "/message/exportToEmail",
        p
    })).save();
}


async function toggleBan(time?: number) {
    if (userdata.value.isBanned || !showFreeDialogForSite()) {
        let newValue = !userdata.value.isBanned;
        userdata.value.isBanned = newValue;
        let p: OperatorApplicationApi.OperatorBuddyListSetBanOpenApiModel = {
            username: props.username,
            ban: newValue,
            time: time ? time : undefined
        };
        let result = await (new OperatorApiRequest({
            url: "/buddyList/setBan",
            p,
            silent: true
        })).send();
        if (result.showMessageOnError()) {
            userdata.value.isBanned = !newValue;
        }
    }
}

async function emitCustomEvent(customEventId: string) {
    let p: OperatorApplicationApi.OperatorBuddyListEmitCustomEventOpenApiModel = {
        username: props.username,
        customEventId
    };
    (await (new OperatorApiRequest({
        url: "/buddyList/emitCustomEvent",
        p
    })).send()).showMessageOnError();
}

async function toggleMute() {
    toggleClientMute(userdata.value);
}


function onSideMenuMessageTagClick(tag: OperatorApplicationApi.TaggedMessagesOpenApiModel) {
    chatArea.value.history.showMessageNavigator(CoreUiChatHistoryHelper.taggedMessagesToMessageNavigatorPayload(tag));
}


function showFreeDialogForSite(): boolean {
    return site.value ? OperatorAccountStore.showFreeDialogForSite(site.value.id) : false;
}

function toggleCobrowse() {
    if (isCobrowseAvailable.value && !showFreeDialogForSite()) {
        cobrowse.value = !cobrowse.value;
    }
}

let isCobrowseAvailable = computed(() => {
    return userdata.value.type.isReal && !userdata.value.integration;
});


provide(SHOW_MESSAGE_STATUS_INJECTION_KEY, computed(() => !site.value?.isFree));



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userdata))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(DialogChatArea, {
            ref_key: "chatArea",
            ref: chatArea,
            userdata: _unref(userdata),
            site: _unref(site),
            "buddy-list": __props.buddyList,
            cobrowse: _unref(cobrowse),
            "show-message-search": _unref(showMessageSearch),
            "onUpdate:showMessageSearch": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showMessageSearch) ? (showMessageSearch).value = $event : showMessageSearch = $event))
          }, null, 8, ["userdata", "site", "buddy-list", "cobrowse", "show-message-search"]),
          (_unref(forceShowSideMenu))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "side-menu-overlay",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(forceShowSideMenu) //@ts-ignore
 ? forceShowSideMenu.value = false : forceShowSideMenu = false))
              }))
            : _createCommentVNode("", true),
          (_unref(cobrowse))
            ? (_openBlock(), _createBlock(OperatorApplicationCobrowse, {
                userdata: _unref(userdata),
                key: _unref(userdata).username,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_isRef(cobrowse) //@ts-ignore
 ? cobrowse.value = false : cobrowse = false)),
                class: _normalizeClass({
                    'side-menu': true,
                    show: _unref(forceShowSideMenu)
                })
              }, null, 8, ["userdata", "class"]))
            : (_openBlock(), _createBlock(DialogSideMenu, {
                key: 2,
                userdata: _unref(userdata),
                "buddy-list": __props.buddyList,
                "selected-messages-as-text": _unref(chatArea)?.selectedMessagesToText() ?? '',
                "on-message-tag-click": onSideMenuMessageTagClick,
                "show-message-search": _unref(showMessageSearch),
                "onUpdate:showMessageSearch": _cache[3] || (_cache[3] = ($event: any) => (_isRef(showMessageSearch) ? (showMessageSearch).value = $event : showMessageSearch = $event)),
                onForward: onForward,
                onExportDialog: onExportDialog,
                onToggleCobrowse: toggleCobrowse,
                onToggleBan: toggleBan,
                onToggleMute: toggleMute,
                onEmitCustomEvent: emitCustomEvent,
                class: _normalizeClass({
                    'side-menu': true,
                    show: _unref(forceShowSideMenu)
                })
              }, null, 8, ["userdata", "buddy-list", "selected-messages-as-text", "show-message-search", "class"]))
        ], 64))
      : (!_unref(ClientUserdataStore).isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("h2", null, "Чат не найден", -1),
            _createElementVNode("div", null, " Отсутствует доступ к проекту с данным чатом, либо чат был удалён. ", -1)
          ]))]))
        : _createCommentVNode("", true)
  ]))
}
}

})